import React from "react";
import CenterBookingTemplate from "./CenterBookingTemplate";
import CenterListTemplate from "../CenterListTemplate";
import PAGE_CONSTANTS from "../../constant";
import { setCenterSelected } from "../../../../../Redux/BookMedicalVisit/action";
import { useDispatch } from "react-redux";
import { BookVisitDetails } from "../../../CommonData";
import "./centerVisit.css";

const CenterVisitTemplate = ({ selectedMember, bookAppointment, tpaDetails }) => {
  const dispatch = useDispatch();
  const { [selectedMember?.MemberId]: bookState } = BookVisitDetails();
  const {
    selectedCenter,
    dcList
  } = bookState || {}

  const onBookAppointmentClick = (clinic) => {
    dispatch(setCenterSelected({ memberId: selectedMember?.MemberId, value: clinic}));
  };

  return (
    <>
      {selectedCenter ? (
        <CenterBookingTemplate
          selectedMember={selectedMember}
          bookAppointment={bookAppointment}
          tpaDetails={tpaDetails}
        />
      ) : (
        <CenterListTemplate
          dcList={dcList}
          onBookAppointmentClick={onBookAppointmentClick}
          type={PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE}
        />
      )}
    </>
  );
};

export default CenterVisitTemplate;
